import React from "react";
import { Form } from "react-bootstrap";
import FormError from "../../../FormError";
import LocationSelector from "../../../LocationSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
}

const LocationField = (props: Props) => {
  const { formik } = props;

  return (
    <Form.Group controlId="location">
      <Form.Label>Number of points (locations)</Form.Label>

      <LocationSelector
        value={formik.values.location}
        onChange={value => formik.setFieldValue('location', value)}
      />

      <FormError
        message={formik.errors.location as TFormErrorMessage}
        when={formik.touched.location && Boolean(formik.errors.location)}
      />
    </Form.Group>
  );
}

export default LocationField;
